<template>
  <v-content>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
  </v-content>
</template>

<script>
export default {
  metaInfo () {
    return {
      title: "SILICA - " + this.$route.name?this.$route.name:'Retunable Bottle System'
    }
  }
  
}
</script>

<style>
#core-view {
 margin-bottom: 50px;
}
</style>
